import { render, staticRenderFns } from "./NflTopPlayer.vue?vue&type=template&id=e7ddff7e&scoped=true"
import script from "./NflTopPlayer.vue?vue&type=script&lang=js"
export * from "./NflTopPlayer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7ddff7e",
  null
  
)

export default component.exports